<template>
    <div class="rt-lookup">
        <el-input readonly :placeholder="placeholder" :disabled="disabled" v-model="lookupValue.name" @focus="showLookupDialog">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="showLookupDialog"></i>
        </el-input>
        <rt-lookup-dialog ref="lookupDialog"
                :entity="entity"
                :request-url="dialogRequestUrl"
          :dialog-title="dialogTitle"
                :name-field="nameField"
                :id-field="idField"
                :display-fields="dialogDisplayFields"
                :orderby-fields="dialogOrderbyFields"
                :custom-conditions="dialogCustomConditions"
                :filter-fields="dialogFilterFields"
                :return-fields="dialogReturnFields"
                :new_industry_id="new_industry_id"
                :new_orderId="new_orderId"
                :canCreate="canCreate"
                @data-selected="handleDataSelected">
        </rt-lookup-dialog>
    </div>
</template>

<script>
import RtLookupDialog from "./lookup-dialog";

export default {
  name: "RtLookup",
  props: {
    value: {
      type: Object,
      required: false
    },
    defaultValue: {
      type: Object,
      required: false
    },
    disabled: Boolean,
    entity: {
      type: String,
      required: true
    },
    nameField: String,
    idField: String,
    dialogRequestUrl: String,
    dialogDisplayFields: Array,
    dialogOrderbyFields: String,
    dialogFilterFields: String,
    dialogCustomConditions: String,
    dialogReturnFields: String,
    dialogTitle: String,
    new_industry_id:{
      type:Object,
      required: false
    },
    new_orderId:{
      type: [Object, String],
      required: false
    },
    canCreate: Boolean,
    placeholder: String
  },
  components: {
    "rt-lookup-dialog": RtLookupDialog
  },
  computed: {},
  data() {
    return {
      lookupValue: {}
    };
  },
  watch: {
    value(newValue) {
      this.lookupValue = newValue || {};
    },
    defaultValue(newVal) {
      // console.log("defaultValuenewVal", newVal);
      // console.log("this.value", this.value);
      if (newVal) {
        // console.log(111111111111);
        this.lookupValue = newVal;
        this.$emit('input', newVal);
      }
    }
  },
  mounted() {
    // console.log("$",this.canCreate);
    if (this.value) {
      this.lookupValue = this.value;
    }else if (this.defaultValue) {
      this.lookupValue = this.defaultValue;
      this.$emit("input", this.defaultValue); // 触发更新
    }
  },
  methods: {
    showLookupDialog() {
      if(this.disabled){
        return;
      }

      this.$refs.lookupDialog.show();
    },
    handleDataSelected(val) {
      this.lookupValue = val;
      this.$emit("input", val);

      this.$emit("change", val);
    }
  }
};
</script>



// WEBPACK FOOTER //
// lookup.vue?05a6aefa